<template>
    <div class="impressionDetails">
        <swiperList :swiperStyle="{padding: '0 0 .5rem'}">
            <div class="img">
                <img :src="img">
            </div>
            <h2>{{ currentData.title }}</h2>
            <p>{{ currentData.description }}</p>
            <textContent v-if="levelThreeIndex == 3"></textContent>
            <div class="rich_media" v-if="levelThreeIndex != 3">
                <div class="rich_media_inner">
                    <div class="rich_media_area_primary">
                        <div class="rich_media_area_primary_inner">
                            <div class="rich_media_wrp" v-html="currentData.content">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </swiperList>
        <backButton routerName="impression" zIindex="10"></backButton>
    </div>
</template>

<script>
import textContent from "@/components/textContent";
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import "@/assets/textCss.css";
export default {
    data() { 
        return {
            currentData: {},
            img: "",
        }
    },
    created(){
        this.currentData = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex];
        let reg = new RegExp('[\u4e00-\u9fa5]+$','g');
        console.log(this.currentData.content.match(/[\u4e00-\u9fa5]/g).join("").length);
        console.log(this.levelThreeIndex);
        let arr = this.currentData.images.replace(/\n/g,"").split("<br />");
        arr.forEach(item => {
            if(item.length > 10){
                this.img = this.getImgSrc(item.split("|")[2],false);
            }
        });
    },
    components: {
        textContent
    },
    computed: {
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","levelThreeIndex","specialtyState"])
    },
}
</script>

<style lang="scss" scoped>
.impressionDetails{
    .img{
        width: 100%;
        height: 7.5rem;
        // background: #0cf;
        img{
            height: 100%;
        }
    }
    h2{
        font-size: .56rem;
        color: #333;
        text-align: center;
        font-weight: bold;
        margin-top: .7rem;
    }
    p{
        color: #999;
        font-size: .24rem;
        margin-top: .18rem;
        margin-bottom: .5rem;
        text-align: center;
    }
    .rich_media_wrp {
  font-family: -apple-system-font, BlinkMacSystemFont, "Helvetica Neue",
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei",
    Arial, sans-serif;
    font-size: 16px;
  /deep/div,
  /deep/dl,
  /deep/dt,
  /deep/dd,
  /deep/ul,
  /deep/ol,
  /deep/li,
  /deep/h1,
  /deep/h2,
  /deep/h3,
  /deep/h4,
  /deep/h5,
  /deep/h6,
  /deep/p,
  /deep/th,
  /deep/td,
  /deep/span,
  /deep/b,
  /deep/i,
  /deep/em,
  /deep/strong {
    line-height: 40px;
  }
}
}
</style>